<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="pa-3"
      >
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-row>
        <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">ตระกร้าสินค้า</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
        <v-col xs="12" sm="12" md="4" lg="2" xl="2" cols="12">
          <div class="title_page ma-3">
            <v-btn
              type="button"
              class="btn_back_page"
              elevation="4"
              @click="$router.back()"
              large
              >ย้อนกลับ</v-btn
            >
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
          <v-card elevation="4" style="border-radius: 15px">
            <v-form ref="input_form" @submit.prevent="cartSuccess()">
              <v-card-title>
                <v-row class="mt-2">
                  <v-col cols="8" xs="12" md="12" lg="8" xl="8">
                    <v-radio-group
                      v-if="status_main_store != '1'"
                      v-model="delivery_type"
                      row
                      hide-details=""
                    >
                      <label for="" class="pr-5 bold">
                        กรุณาเลือกการจัดส่ง</label
                      >
                      <v-radio
                        label="รับที่ร้านฟาร์มาแคร์ (ฟรี)"
                        value="1"
                        color="#B0886B"
                      ></v-radio>
                      <v-radio
                        label="จัดส่งในเชียงใหม่ (ฟรี)"
                        value="2"
                        color="#B0886B"
                      ></v-radio>
                      <v-radio
                        label="จัดส่งทั่วประเทศ (ค่าส่งคิดตามน้ำหนัก)"
                        value="3"
                        color="#B0886B"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col
                    cols="4"
                    xs="12"
                    md="12"
                    lg="4"
                    xl="4"
                    class="d-flex"
                    style="justify-content: end"
                  >
                    <div
                      v-if="status_main_store != '1'"
                      class="cart_total pa-2 mr-2"
                    >
                      <div>
                        ค่าส่ง
                        {{
                          format_price(
                            parseFloat(delivery_type != "3" ? 0 : rate)
                          )
                        }}
                        บาท
                      </div>
                    </div>
                    <div class="cart_total pa-2" v-if="customer_type != 3">
                      <div>
                        ราคา
                        {{
                          format_price(
                            data_list.reduce((sum, number) => {
                              return sum + number.cost * number.quantity;
                            }, 0)
                          )
                        }}
                        บาท
                      </div>
                    </div>
                  </v-col>

                  <v-col
                    v-if="delivery_type == '1' && status_main_store != '1'"
                  >
                    <div style="text-align: center">
                      ฟาร์มาแคร์ พลัส (สำนักงานใหญ่) เบอร์โทรติดต่อ 053272123
                      ที่อยู่ 197/3-4 ถ.เชียงใหม่-หางดง ต.ป่าแดด อ.เมือง
                      จ.เชียงใหม่
                    </div>
                  </v-col>
                  <v-col
                    v-if="delivery_type == '2' && status_main_store != '1'"
                  >
                    <div style="text-align: center">
                      {{ address_data.address }} {{ address_data.address_list }}
                    </div>
                  </v-col>
                  <v-col
                    v-if="delivery_type == '3' && status_main_store != '1'"
                    cols="12"
                  >
                    <v-card>
                      <v-card-text>
                        <v-row>
                          <v-col cols="6">
                            <v-form-group>
                              <label for=""
                                >ชื่อ-นามสกุล
                                <span style="color: red">*</span></label
                              >
                              <v-text-field
                                v-model="address_data.name"
                                :rules="[
                                  (v) =>
                                    v[0] !== ' ' ||
                                    'กรุณาอย่าป้อนค่าว่างตัวแรก',
                                  (v) => !!v || 'กรุณากรอกข้อมูล',
                                ]"
                                maxlength="50"
                                color="#D6BFAF"
                                hide-details="auto"
                                outlined
                                dense
                              ></v-text-field>
                            </v-form-group>
                          </v-col>
                          <v-col cols="6">
                            <v-form-group>
                              <label for=""
                                >เบอร์โทรติดต่อ
                                <span style="color: red">*</span></label
                              >
                              <v-text-field
                                v-model="address_data.telephone"
                                :rules="[(v) => !!v || 'กรุณากรอกข้อมูล']"
                                maxlength="10"
                                @keypress="
                                  isTelephone($event, address_data.telephone)
                                "
                                color="#D6BFAF"
                                hide-details="auto"
                                outlined
                                dense
                              ></v-text-field>
                            </v-form-group>
                          </v-col>
                          <v-col cols="12">
                            <v-form-group>
                              <label for=""
                                >ที่อยู่จัดส่ง
                                <span style="color: red">*</span></label
                              >
                              <v-text-field
                                v-model="address_data.address"
                                :rules="[
                                  (v) =>
                                    v[0] !== ' ' ||
                                    'กรุณาอย่าป้อนค่าว่างตัวแรก',
                                  (v) => !!v || 'กรุณากรอกข้อมูล',
                                ]"
                                color="#D6BFAF"
                                hide-details="auto"
                                outlined
                                dense
                              ></v-text-field>
                            </v-form-group>
                          </v-col>
                          <v-col cols="12">
                            <v-form-group>
                              <label for=""
                                >ตำบล/อำเภอ/จังหวัด/รหัสไปรษณีย์
                                <span style="color: red">*</span></label
                              >
                              <v-autocomplete
                                color="#D6BFAF"
                                class="input-radius"
                                prepend-inner-icon="mdi-home"
                                hide-details="auto"
                                :items="addressList"
                                item-text="name"
                                item-value="name"
                                v-model="address_data.address_list"
                                :rules="[(v) => !!v || 'กรุณากรอกข้อมูล']"
                                placeholder="ตำบล /อำเภอ /จังหวัด /รหัสไปรษณีย์ "
                                single-line
                                outlined
                                dense
                              >
                              </v-autocomplete>
                            </v-form-group>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                    <v-data-table
                      :headers="computedHeaders"
                      :items="data_list"
                      :search="search"
                      :footer-props="footer_Props"
                      mobile-breakpoint="0"
                    >
                      <template v-slot:item="dataDetail">
                        <tr>
                          <td class="hidden_line pa-3">
                            <div class="text-center">
                              <v-img
                                height="80"
                                max-width="80"
                                :lazy-src="dataDetail.item.product_pic"
                                :src="dataDetail.item.product_pic"
                                class="preview"
                              ></v-img>
                            </div>
                          </td>
                          <td class="hidden_line">
                            <div>{{ dataDetail.item.product_name }}</div>
                            <div class="grey--text">
                              <small>{{ dataDetail.item.name_sci }}</small>
                            </div>
                            <div class="d-flex">
                              <div
                                class="my-2 tag_border_unit tag_border_unit_active"
                              >
                                {{ dataDetail.item.unit_name }}
                              </div>
                            </div>
                          </td>
                          <td class="hidden_line" v-if="customer_type != 3">
                            <div class="text-center">
                              ฿ {{ dataDetail.item.cost }}
                            </div>
                          </td>
                          <td class="hidden_line">
                            <div style="display: flex; justify-content: center">
                              <v-btn
                                class="mt-1"
                                color="#D6BFAF"
                                height="17px"
                                width="17px"
                                style="
                                  border-radius: 5px;
                                  border-color: #d6bfaf;
                                "
                                @click="subtractQuantity(dataDetail.item)"
                                fab
                                x-small
                                dark
                                outlined
                              >
                                <v-icon>mdi-minus</v-icon>
                              </v-btn>
                              <p class="ml-2 mr-2">
                                {{ dataDetail.item.quantity }}
                              </p>
                              <v-btn
                                class="mt-1"
                                color="#D6BFAF"
                                height="17px"
                                width="17px"
                                style="
                                  border-radius: 5px;
                                  border-color: #d6bfaf;
                                "
                                @click="addQuantity(dataDetail.item)"
                                fab
                                x-small
                                dark
                                outlined
                              >
                                <v-icon>mdi-plus</v-icon>
                              </v-btn>
                            </div>
                          </td>
                          <td class="hidden_line" v-if="customer_type != 3">
                            <div class="text-center">
                              ฿
                              {{
                                format_price(
                                  dataDetail.item.cost *
                                    dataDetail.item.quantity
                                )
                              }}
                            </div>
                          </td>
                          <td class="hidden_line">
                            <v-btn
                              elevation="3"
                              class="ma-2"
                              outlined
                              small
                              height="45"
                              color="error"
                              title="ลบข้อมูล"
                              @click="deleteCart(dataDetail.item.cart_id)"
                              style="
                                border-radius: 10px;
                                background-color: #ffffff;
                              "
                            >
                              <v-icon>mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-col>
                  <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                    <div
                      class="title_page ma-3"
                      style="justify-content: center"
                    >
                      <v-btn
                        v-if="data_list.length > 0"
                        type="submit"
                        class="btn_add_data_submit"
                        elevation="4"
                        large
                        >สั่งซื้อสินค้า</v-btn
                      >
                      <v-btn
                        v-else
                        type="submit"
                        class="btn_add_data_submit"
                        elevation="4"
                        large
                        disabled
                        >สั่งซื้อสินค้า</v-btn
                      >
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import img_holder from "@/assets/arin_assets/image_sun_color.png";
import { HTTP_ARIN } from "@/axios_arin";
import { formatPrice, isTelephone } from "@/js/handler";
import Swal from "sweetalert2";

export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Pos_cart_list",
  data() {
    return {
      customer_type: null,
      loading_page: true,
      img_holder: img_holder,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        "items-per-page-text": "รายการต่อหน้า",
      },
      sub_menu: [
        {
          text: "ระบบ POS",
          disabled: false,
        },
        {
          text: "ออกใบสั่งซื้อ",
          disabled: false,
        },
        {
          text: "รายการสินค้า",
          disabled: false,
        },
        {
          text: "ตระกร้าสินค้า",
          disabled: false,
          href: "#",
        },
      ],

      headers: [
        {
          text: "รูปภาพ",
          value: "",
          fixed: true,
          width: "120px",
          sortable: false,
          align: "center",
        },
        {
          text: "ชื่อสินค้า",
          value: "",
          fixed: true,
          width: "300px",
          align: "left",
        },
        {
          text: "ราคาต่อหน่วย",
          value: "",
          fixed: true,
          width: "160px",
          align: "center",
        },
        {
          text: "จำนวน",
          value: "",
          fixed: true,
          width: "120px",
          align: "center",
        },
        {
          text: "ราคารวม",
          value: "",
          fixed: true,
          width: "160px",
          align: "center",
        },
        {
          text: "ลบ",
          value: "",
          fixed: true,
          width: "60px",
          sortable: false,
          align: "left",
        },
      ],
      size_list: [
        { id: 5, name: "5" },
        { id: 10, name: "10" },
        { id: 15, name: "15" },
        { id: "all", name: "All" },
      ],
      page: 1,
      size: 10,
      delivery_type: "1",
      count_page: 1,
      data_list: [],
      addressList: [],
      address_data: {},
      rate: 0,
      status_main_store: 0,
    };
  },
  methods: {
    getShow_api() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };

      HTTP_ARIN.get("/profile/detail", config).then((res) => {
        if (res.data.successful === true) {
          // ถ้า login มาจาก customer (เจ้าของร้าน)
          if (res.data.ProfileDetail) {
            this.customer_type = res.data.ProfileDetail.customer_type;
          }

          // ถ้า login มาจาก employee (พนักงาน)
          else if (res.data.ProfileDetail_emp) {
            this.customer_type = res.data.ProfileDetail.customer_type;
          }
        }
      });
    },
    format_price: function (value) {
      return formatPrice(value);
    },
    isTelephone: function (evt, value) {
      return isTelephone(evt, value);
    },
    async addQuantity(item) {
      if (item.quantity >= 0) {
        item.quantity++;
        const config = {
          headers: {
            Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
          },
        };
        if (item.type_product == 1) {
          const data = {
            product_id: item.product_id,
            unit_id: item.unit_id,
            quantity: item.quantity,
          };
          await HTTP_ARIN.post(
            "/pos/product/check/special/price",
            data,
            config
          ).then((res) => {
            if (res.data.successful === true) {
              item.cost = res.data.cost;
            }
          });
        }
        const update_data = {
          cart_id: item.cart_id,
          quantity: 1,
          cost: item.cost,
          total: item.cost * item.quantity,
        };
        await HTTP_ARIN.post("/pos/update/cart", update_data, config).then(
          (res) => {
            if (res.data.successful === true) {
              this.rate = res.data.rate;
            }
          }
        );
      }
    },
    async subtractQuantity(item) {
      if (item.quantity > 1) {
        item.quantity--;
        const config = {
          headers: {
            Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
          },
        };
        if (item.type_product == 1) {
          const data = {
            product_id: item.product_id,
            unit_id: item.unit_id,
            quantity: item.quantity,
          };
          await HTTP_ARIN.post(
            "/pos/product/check/special/price",
            data,
            config
          ).then((res) => {
            if (res.data.successful === true) {
              item.cost = res.data.cost;
            }
          });
        }
        const update_data = {
          cart_id: item.cart_id,
          quantity: -1,
          cost: item.cost,
          total: item.cost * item.quantity,
        };
        HTTP_ARIN.post("/pos/update/cart", update_data, config).then((res) => {
          if (res.data.successful === true) {
            this.rate = res.data.rate;
          }
        });
      }
    },
    async getCartList() {
      this.loading_page = true;
      this.data_list = [];
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.get("/pos/get/cart/all", config).then((res) => {
        if (res.data.successful === true) {
          this.data_list = res.data.cart;
          this.rate = res.data.rate;
          this.loading_page = false;
        }
      });
    },
    async deleteCart(id) {
      Swal.fire({
        // title: 'คุณต้องการลบข้อมูลหรือไม่?',
        text: "คุณต้องการลบข้อมูลหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading_page = true;
          const config = {
            headers: {
              Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
            },
          };
          HTTP_ARIN.get("/pos/delete/cart/" + id, config).then((res) => {
            if (res.data.successful === true) {
              this.getCartList();
            }
          });
        }
      });
    },
    getAddress_api() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.get("/stores/addresslist", config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          this.addressList = res.data.addressList;
        }
      });
    },
    async cartSuccess() {
      if (this.$refs.input_form.validate()) {
        Swal.fire({
          // title: 'ยืนยันรายการสั่งซื้อสินค้า?',
          text: "ยืนยันรายการสั่งซื้อสินค้า?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
        }).then((result) => {
          if (result.isConfirmed) {
            this.loading_page = true;
            const total = this.data_list.reduce((sum, number) => {
              return sum + number.cost * number.quantity;
            }, 0);
            let customer_type = {
              order_type: null,
              delivery_type: null,
              delivery_price: null,
              tax_invoice: null,
            };
            // ลูกค้าปลีก
            if (this.$store.state.store_arin.user_data.customer_type == 0) {
              customer_type = {
                order_type: 2,
                delivery_type: 1,
                delivery_price: 0,
                tax_invoice: 0,
              };
            }
            // ลูกค้าส่งเงินสด
            if (this.$store.state.store_arin.user_data.customer_type == 1) {
              customer_type = {
                order_type: 2,
                delivery_type: 1,
                delivery_price: this.delivery_type == "3" ? this.rate : 0,
                tax_invoice: 0,
              };
            }
            // ลูกค้าส่งเครดิต
            if (this.$store.state.store_arin.user_data.customer_type == 2) {
              customer_type = {
                order_type: 2,
                delivery_type: 1,
                delivery_price: this.delivery_type == "3" ? this.rate : 0,
                tax_invoice: 0,
              };
            }
            // พาร์ทเนอร์
            if (this.$store.state.store_arin.user_data.customer_type == 3) {
              customer_type = {
                order_type: 2,
                delivery_type: 1,
                delivery_price: 0,
                tax_invoice: 0,
              };
            }

            const data = {
              order_type: customer_type.order_type,
              delivery_type: this.delivery_type,
              name: this.address_data.name,
              telephone: this.address_data.telephone,
              address:
                this.delivery_type == "3"
                  ? `${this.address_data.address_delivery} ${
                      this.address_data.address_list.split(",")[0]
                    }${this.address_data.address_list.split(",")[1]}${
                      this.address_data.address_list.split(",")[2]
                    }${this.address_data.address_list.split(",")[3]}`
                  : `${this.address_data.address_delivery} ${this.address_data.sub_district_delivery} ${this.address_data.district_delivery} ${this.address_data.province_delivery} ${this.address_data.postcode_delivery}`,
              address_delivery: this.address_data.address_delivery,
              sub_district_delivery:
                this.delivery_type == "3"
                  ? this.address_data.address_list.split(",")[0]
                  : this.address_data.sub_district_delivery,
              district_delivery:
                this.delivery_type == "3"
                  ? this.address_data.address_list.split(",")[1]
                  : this.address_data.district_delivery,
              province_delivery:
                this.delivery_type == "3"
                  ? this.address_data.address_list.split(",")[2]
                  : this.address_data.province_delivery,
              postcode_delivery:
                this.delivery_type == "3"
                  ? this.address_data.address_list.split(",")[3]
                  : this.address_data.postcode_delivery,
              delivery_price: customer_type.delivery_price,
              total: total,
              tax_invoice: customer_type.tax_invoice,
            };

            const config = {
              headers: {
                Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
              },
            };
            HTTP_ARIN.post("/pos/submit/cart", data, config).then((res) => {
              if (res.data.successful === true) {
                this.loading_page = false;
                let timerInterval;
                Swal.fire({
                  title: "เสร็จสิ้น",
                  text: "สั่งซื้อสินค้าเรียบร้อยแล้ว",
                  icon: "success",
                  timer: 2000,
                  timerProgressBar: true,
                  didOpen: () => {
                    Swal.showLoading();
                    timerInterval = setInterval(() => {});
                  },
                  willClose: () => {
                    clearInterval(timerInterval);
                    setTimeout(function () {
                      window.location.href = "/arin/pos/productlist";
                    });
                  },
                });
              }
            });
          }
        });
      } else {
        Swal.fire({
          title: "คำเตือน!",
          text: "กรุณากรอกข้อมูลจัดส่งให้ครบถ้วน",
          icon: "warning",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "ตกลง",
        });
      }
    },
    async getSotre() {
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      let store_id = this.$store.state.store_arin.user_data.store_id;
      await HTTP_ARIN.get("/stores/detail/" + store_id, config).then((res) => {
        if (res.data.successful === true) {
          this.address_data = {
            order_type: null,
            delivery_type: this.delivery_type,
            name: res.data.storeDetail.store_name,
            telephone: res.data.storeDetail.tel,
            address: res.data.storeDetail.address,
            address_list: res.data.storeDetail.address_list,
            address_full: null,
            address_delivery: res.data.storeDetail.address,
            sub_district_delivery: res.data.storeDetail.sub_district,
            district_delivery: res.data.storeDetail.district,
            province_delivery: res.data.storeDetail.province,
            postcode_delivery: res.data.storeDetail.postcode,
            delivery_price: null,
            total: null,
            tax_invoice: null,
          };
          this.status_main_store = res.data.storeDetail.status_main_store;
        }
      });
    },
  },
  computed: {
    computedHeaders() {
      const baseHeaders = [
        {
          text: "รูปภาพ",
          value: "image", // กำหนด value ให้ถูกต้องตาม key ในข้อมูล
          fixed: true,
          width: "120px",
          sortable: false,
          align: "center",
        },
        {
          text: "ชื่อสินค้า",
          value: "name", // กำหนด value
          fixed: true,
          width: "300px",
          align: "left",
        },
        // ส่วนนี้จะถูกเพิ่มเข้ามาก็ต่อเมื่อ customer_type ไม่ใช่ 3
        // {
        //   text: 'ราคาต่อหน่วย',
        //   value: 'unit_price', // กำหนด value
        //   fixed: true,
        //   width: '160px',
        //   align: 'center',
        // },
        {
          text: "จำนวน",
          value: "quantity", // กำหนด value
          fixed: true,
          width: "120px",
          align: "center",
        },
        // ส่วนนี้จะถูกเพิ่มเข้ามาก็ต่อเมื่อ customer_type ไม่ใช่ 3
        // {
        //   text: 'ราคารวม',
        //   value: 'total_price', // กำหนด value
        //   fixed: true,
        //   width: '160px',
        //   align: 'center',
        // },
        {
          text: "ลบ",
          value: "actions", // กำหนด value
          fixed: true,
          width: "60px",
          sortable: false,
          align: "left",
        },
      ];

      // ถ้า customer_type ไม่ใช่ 3 (หรือยังเป็น null) ให้เพิ่มคอลัมน์ราคา
      if (this.customer_type !== 3) {
        // คัดลอก baseHeaders เพื่อไม่ให้กระทบ array เดิม
        const updatedHeaders = [...baseHeaders];

        // แทรก 'ราคาต่อหน่วย' ก่อน 'จำนวน'
        updatedHeaders.splice(2, 0, {
          // splice(index, deleteCount, item1, item2, ...)
          text: "ราคาต่อหน่วย",
          value: "unit_price",
          fixed: true,
          width: "160px",
          align: "center",
        });

        // แทรก 'ราคารวม' ก่อน 'ลบ' (หลังจากที่แทรก 'ราคาต่อหน่วย' เข้าไปแล้ว index จะเลื่อนไป 1)
        updatedHeaders.splice(5, 0, {
          // index 5 เพราะ 'จำนวน' อยู่ที่ index 4 (เดิม) และ 'ราคาต่อหน่วย' แทรกเข้ามาที่ index 2
          text: "ราคารวม",
          value: "total_price",
          fixed: true,
          width: "160px",
          align: "center",
        });

        return updatedHeaders;
      } else {
        // ถ้า customer_type เป็น 3 ให้ส่ง baseHeaders (ที่ไม่มีคอลัมน์ราคา)
        return baseHeaders;
      }
    },
  },
  created() {
    this.getCartList();
    this.getAddress_api();
    this.getSotre();
    this.getShow_api();
  },
};
</script>

<style scoped>
.cart_total {
  border: 1px solid #88b358;
  color: #88b358;
  font-weight: 700;
  font-size: 24px;
  border-radius: 10px;
}

.width >>> input {
  max-width: 100%;
  text-align: center;
}

.preview {
  border-radius: 10px;
  margin: auto;
}

.mobile_btn {
  width: 15%;
}

.btn_add_data_submit {
  font-size: 16px;
  color: #fff;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%),
    #88b358 !important;
  border-radius: 10px;
  width: 15%;
}

@media only screen and (min-width: 0px) AND (max-width: 361px) {
  .inp-text-field {
    width: 100%;
  }

  .btn_add_data_submit {
    font-size: 16px;
    color: #fff;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%),
      #88b358 !important;
    border-radius: 10px;
    width: 100% !important;
  }

  .btn_exp_list {
    width: 100%;
  }
}

@media only screen and (max-width: 600px) {
  .inp-text-field {
    width: 100%;
  }

  .btn_add_data_submit {
    font-size: 16px;
    color: #fff;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%),
      #88b358 !important;
    border-radius: 10px;
    width: 100%;
  }

  .btn_exp_list {
    width: 100%;
  }
}

@media only screen and (min-width: 601px) AND (max-width: 960px) {
  .inp-text-field {
    width: 100%;
  }

  .btn_exp_list {
    width: 100%;
  }
}

@media only screen and (min-width: 961px) AND (max-width: 1264px) {
  .inp-text-field {
    width: 50%;
  }
}

/* @media only screen and (min-width: 1265px) AND (max-width: 1904px) {
  .inp-text-field {
    width: 23%;
  }
} */
</style>
